import React, { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import "./DepartmentTickets.scss";
import Axios from "../../Helpers/Interceptors";
import {
  Table,
  Button,
  Space,
  Select,
  DatePicker,
  TimePicker,
  Tabs,
  Tag,
  Card
} from "antd";

import { useNavigate } from "react-router-dom";
import { Link, useLocation } from "react-router-dom";

const formatDateUS = (date) => {
  return new Date(date).toLocaleDateString("en-US");
};

export default function DepartmentTickets() {
  const [formValues, setFormValues] = useState({
    ticketNumber: '',
    ticketType: '',
    status: null,
    selectedAgents: null,
  });

  const { Option } = Select;
  const navigate = useNavigate();
  const [list, setlist] = useState([]);
  const [list1, setlist1] = useState([]);
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("all-tickets");

  const [pagination, setPagination] = useState({
    page: 1,
    size: 10,
    total: 0, // You’ll get the total count of records from your API response
  });
  const handleSearch = () => {
    const { ticketNumber, ticketType, status, selectedAgents } = formValues;

    const filtered = list1.filter((item) => {
      const matchesTicketNumber = ticketNumber
        ? item.ticketNumber?.toLowerCase().includes(ticketNumber.toLowerCase())
        : true;

      const matchesTicketType = ticketType
        ? item.request_type?.toLowerCase().includes(ticketType.toLowerCase())
        : true;

      const matchesStatus = status
        ? item.status === status
        : true;



      return matchesTicketNumber && matchesTicketType && matchesStatus ;
    });
    setlist(filtered)
  }

  const columns = [
    {
      title: "Ticket Number",
      dataIndex: "ticketNumber",
      key: "ticketNumber",
    },
    {
      title: "Request Type",
      dataIndex: "request_type",
      key: "request_type",
    },
    {
      title: "Request Sub Type",
      dataIndex: "request_subtype",
      key: "request_subtype",
    },
    {
      title: "Agent",
      dataIndex: "assignedByAgent",
      key: "assignedByAgent",
    },



    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Priority",
      dataIndex: "priority",
      key: "priority",
      render: (record) => (
        <div
          style={{
            color:
              record === "High"
                ? "red"
                : record === "Medium"
                  ? "orange"
                  : record === "Low" || !record
                    ? "green"
                    : "black", // Default color if none matches
            fontWeight: "bold",
          }}
        >
          {record ? record : "Low"}
        </div>
      ),
    },

    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",

      render: (record) => formatDateUS(record),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "address",
      align: "center",
      render: (_, record) => (
        <div
          onClick={() => navigate(`/tickets-detail-department/${record.ticketNumber}`)}
          style={{ cursor: "pointer" }}
        >
          <i className="bx bx-show" style={{ fontSize: "20px" }}></i>
        </div>
      ),
    },
  ];
  useEffect(() => {
    fetchData(pagination.page, pagination.size);
  }, []);

  const handlePaginationChange = (page, pagesize) => {
    console.log("asd", page, pagesize);
    setPagination((prev) => ({ ...prev, page: page, size: pagesize }));
    fetchData(page, pagesize);
  };

  const fetchData = async (page, size) => {
    const obj = {
      page: page,
      size: size,
    };
    try {
      const response = await Axios.get(
        `https://demo.tscti.com/api/departments/assigned-tickets?page=${page-1}&size=${500}`
      );

      setlist(response.data.incidents);
      setlist1(response.data.incidents);
      // setPagination((prop) => ({
      //   ...prop,
      //   total: response.data.totalReportedIncidents || 0, // Set total from the response
      // }));
    } catch (err) {
      console.log(err.message);
    } finally {
      console.log(false);
    }
  };

  const displayedList =
  activeTab === "resolved-tickets"
    ? list.filter((ticket) => ticket.status === "Resolved")
    : list;

  return (
    <div
      className="signup-content2 card"
      style={{ paddingLeft: "2%", paddingRight: "2%", paddingTop: "1%", height: '100vh',background:'white' }}
    >

         {/* Tabs */}
         <div className="d-flex w-100 border border-start-0 border-top-0 border-end-0">
        <div
          onClick={() => setActiveTab("all-tickets")}
          className={`px-4 py-3 border-end text-decoration-none text-muted ${
            activeTab === "all-tickets" ? "bg-white fw-bold" : "bg-light"
          }`}
          style={{
            flex: 1,
            textAlign: "center",
            fontFamily: "Poppins, sans-serif",
            fontWeight: "700",
            cursor: "pointer",
          }}
        >
          All tickets
        </div>

        <div
          onClick={() => setActiveTab("my-tickets")}
          className={`px-4 py-3 border-end text-decoration-none text-muted ${
            activeTab === "my-tickets" ? "bg-white fw-bold" : "bg-light"
          }`}
          style={{
            flex: 1,
            textAlign: "center",
            fontFamily: "Poppins, sans-serif",
            fontWeight: "700",
            cursor: "pointer",
          }}
        >
          My tickets
        </div>

        <div
          onClick={() => setActiveTab("resolved-tickets")}
          className={`px-4 py-3 text-decoration-none text-muted ${
            activeTab === "resolved-tickets" ? "bg-white fw-bold" : "bg-light"
          }`}
          style={{
            flex: 1,
            textAlign: "center",
            fontFamily: "Poppins, sans-serif",
            fontWeight: "700",
            cursor: "pointer",
          }}
        >
          Resolved tickets
        </div>
      </div>


      {/* <div
        className="card  mb-3  p-2 mt-3"
        style={{
          background:
            "#0e2b4e",
          textAlign: "left",
        }}
      >
        <h5 style={{ color: "whitesmoke", marginBottom: '0px' }}> Assigned Tickets </h5>
      </div> */}

      <div className="bg-gradient  rounded filter">
        <div className="row">
          <div className="col-md-2 col-lg-2">
            <label className="label-heading1" style={{color:'black' , marginRight:'45%'}}>Ticket Number</label>
            <input
              className={`form-input-department
                          `}
              name="ticketNumber"
              id="ticketNumber"
              placeholder="Ticket Number*"
              autoComplete="new-password"
              value={formValues.ticketNumber}
              onChange={(e) => setFormValues(prev => ({ ...prev, ticketNumber: e.target.value }))}
            />
          </div>
          <div className="col-md-2 col-lg-2">
            <label className="label-heading1"  style={{color:'black' , marginRight:'45%'}}>Ticket Type</label>
            <input
              className={`form-input-department`}
              name="request_type"
              id="request_type"
              placeholder="Ticket Type*"
              autoComplete="new-password"
              value={formValues.ticketType}
              onChange={(e) => setFormValues(prev => ({ ...prev, ticketType: e.target.value }))}
            />
          </div>

          <div className="col-md-2 col-lg-2">
            <label className="label-heading1"  style={{color:'black' , marginRight:'72%'}}>Status</label>
            <Select
              style={{
                width: "100%",
                height: '65%',
                background: "#fff !important",
                borderColor: "grey !important",
              }}
              placeholder="Status*"
              onChange={(value) => setFormValues(prev => ({ ...prev, status: value }))}
              options={[
                { value: "Reported", label: "Reported" },
                { value: "In Progress", label: "In Progress" },
                {
                  value: "Assign To DPT",
                  label: "Assign to DPT",
                },
                {
                  value: "Resolved",
                  label: "Resolved",
                },
              ]}
            />
          </div>



          <div className="col-md-3 col-lg-3">
            <div className="filter-button">
              <button
                className="btn btn-style btn-save"
                style={{ background: "#0e2b4e", color: "whitesmoke" }} onClick={()=>handleSearch()}
              >
                <i className="fas fa-search" style={{ marginRight: "8px" }}></i> Search
              </button>

              <button
                className="btn btn-style btn-cancel"
                style={{ background: "#F44336", color: "whitesmoke" }}
                onClick={() => {setlist(list1);   setFormValues({
                  ticketNumber: '',
                  ticketType: '',
                  status: null,


                })}}
              >
                <i className="fas fa-times" style={{ marginRight: "8px" }}></i>{" "}
                Cancel
              </button>

            </div>
          </div>
        </div>

      </div>

      <div className="bg-gradient p-2 rounded colr-table" style={{ position: "relative" }}>
        <Table
          // dataSource={list}
          dataSource={displayedList}
          columns={columns}
          scroll={{ y: 350 }}
          rowClassName={() => "custom-row"}
          pagination={{
            showSizeChanger: true,
            onChange: handlePaginationChange,

            current: pagination.page,
            pageSize: pagination.size,

            total: pagination.total,

            showTotal: (total, range) => (
              <span style={{ color: "whitesmoke" }}>
                Total {total} records, showing {range[0]} to {range[1]}
              </span>
            ),
          }}
        />
        {/* <div
          className="table-header"
          style={{
            background: "rgb(5, 162, 179)",
          }}
        >
          <h4 style={{ fontFamily: "Myriad Pro" }}>Agent Care Tickets</h4>
        </div> */}
        ;
      </div>
    </div>
  );
}

